import React from "react";
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Dialog from "../../../library/Dialog";
import { DetailRow, formatDateTime, statusLabel } from "../partnerShared";

export default function PromoCodeDetailDialog({ detail, loading, error, onClose }) {
  return (
    <Dialog
      open={Boolean(detail)}
      onClose={onClose}
      title={detail?.promo_code || "Promo code"}
      subtitle='View the offer, redemption status, linked user, and subscription.'
      icon={<VisibilityOutlinedIcon />}
      cancelText='Close'
      hideConfirmButton
    >
      {loading ? (
        <Stack direction='row' spacing={1.5} alignItems='center' sx={{ py: 3 }}>
          <CircularProgress size={18} />
          <Typography variant='body2' color='text.secondary'>
            Loading details...
          </Typography>
        </Stack>
      ) : error ? (
        <Alert severity='error'>{error}</Alert>
      ) : (
        <Stack spacing={2.5}>
          <Stack spacing={1}>
            <DetailRow label='Partner' value={detail?.partner_name} />
            <DetailRow label='Status' value={detail ? statusLabel(detail) : ""} />
            <DetailRow
              label='Discount'
              value={detail?.discount_value != null ? `${detail.discount_value}%` : ""}
            />
            <DetailRow label='Expires' value={formatDateTime(detail?.expires_at)} />
            <DetailRow label='Redeemed' value={formatDateTime(detail?.redeemed_at)} />
            <DetailRow label='Reference' value={detail?.external_reference_id} />
          </Stack>
          <Box>
            <Typography variant='subtitle2' fontWeight={700} sx={{ mb: 1 }}>
              Linked user
            </Typography>
            {detail?.user ? (
              <Stack spacing={1}>
                <DetailRow label='Name' value={detail.user.name} />
                <DetailRow label='Email' value={detail.user.email} />
                <DetailRow label='User id' value={detail.user.u_id} />
              </Stack>
            ) : (
              <Typography variant='body2' color='text.secondary'>
                Nobody has used this code yet.
              </Typography>
            )}
          </Box>
          <Box>
            <Typography variant='subtitle2' fontWeight={700} sx={{ mb: 1 }}>
              Subscription
            </Typography>
            {detail?.subscription ? (
              <Stack spacing={1}>
                <DetailRow label='Subscription id' value={detail.subscription.id} />
                <DetailRow label='Status' value={detail.subscription.status} />
                <DetailRow
                  label='Discount on subscription'
                  value={
                    detail.subscription.custom_discount_percent != null
                      ? `${detail.subscription.custom_discount_percent}%`
                      : "None"
                  }
                />
                <DetailRow label='Plan' value={detail.subscription.plan_id} />
                <DetailRow label='Trial ends' value={formatDateTime(detail.subscription.trial_end)} />
              </Stack>
            ) : (
              <Typography variant='body2' color='text.secondary'>
                No subscription yet. Email signups get one after they verify.
              </Typography>
            )}
          </Box>
          {detail?.pending_user && (
            <Alert severity='info' icon={<InfoOutlinedIcon />}>
              {detail.pending_user.email || detail.pending_user.name} hasn't finished signing up, so
              this code is still waiting.
            </Alert>
          )}
        </Stack>
      )}
    </Dialog>
  );
}
